import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import TextareaInput from "../../Components/Inputs/TextareaInput";
import ImageInput from "../../Components/Inputs/ImageInput";

export default function ({ register, errors, control, data, watch }) {

    return (<>
        <ImageInput
            name="logo"
            parentClasses="col-md-4 col-sm-5"
            classes="d-inline-block"
            register={register}
            control={control}
            errorMessage={errors?.logo}
        />
        <TextInput
            label="Name"
            name="name"
            parentClasses="col-md-8 col-sm-7"
            register={register}
            required={true}
            errorMessage={errors?.name}
        />
        <TextareaInput
            label="Description"
            name="description"
            register={register}
            rows={3}
            event={true}
            watch={watch}
            maxChars={225}
            errorMessage={errors?.description}
        />

        <TextareaInput
          label="Keywords"
          name="keywords"
          register={register}
          required={false}
          rows={3}
          event={true}
          watch={watch}
          errorMessage={errors?.keywords}
        />

        <div className="text-muted fs-7 mb-5">
            Set keywords to the brand separated by comma ( ex: word1, word2, word3 )
        </div>
    </>);
}